import { GuestDetails, RsvpDetails, StepsTranslationsStrings } from "../../models/api/rsvpApiTypes"
import { CORE_STEP_NAMES, TranslationsStringsType } from "../../models/enum/rsvpEnum"
import useStepNavigation from "../../hook/useStepNavigation"
import BooleanSwitch from "../Inputs/BooleanSwitch"

interface StepBusProps {
  buttonColor?: string
  backButtonColor?: string
  strings?: StepsTranslationsStrings[]
  rsvp: RsvpDetails
  setRsvp: (rsvp: RsvpDetails) => void
  setStep: (name: string) => void
  stepPipeline: string[]
}

export default function StepBus({
  buttonColor,
  backButtonColor,
  strings,
  rsvp,
  setStep,
  stepPipeline,
  setRsvp,
}: StepBusProps) {
  const { goNext, goPrevious } = useStepNavigation(stepPipeline, CORE_STEP_NAMES.BUS, setStep)

  const setFlag = (busTransferNeeded: boolean, guest: GuestDetails) => {
    const newGuests = rsvp.invitation.guests.map((g) => {
      if (g.id === guest.id) {
        g = {
          ...guest,
          rsvp: {
            accepted: g.rsvp.accepted,
            arrivalDate: g.rsvp.arrivalDate,
            email: g.rsvp.email,
            intolerances: g.rsvp.intolerances,
            busTransferNeeded,
          },
        }
      }
      return g
    })
    setRsvp({ ...rsvp, invitation: { ...rsvp.invitation, guests: newGuests } })
  }

  return (
    <>
      <div style={{ display: "flex", justifyContent: "right", color: "#27272E", fontWeight: "bold" }}>
        {strings?.find((x) => x.type === TranslationsStringsType.VALUETITLE)?.value}
      </div>
      {rsvp.invitation.guests.map((guest) => (
        <div key={guest.id} style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "5px" }}>
          {guest.rsvp.accepted && guest.rsvpSettings.showBusTransferNeeded && (
            <>
              <label className="box-form-label">
                {guest.name} {guest.surname}
              </label>
              <BooleanSwitch
                checked={guest.rsvp.busTransferNeeded ?? false}
                onChange={(checked) => setFlag(checked, guest)}
              />
            </>
          )}
        </div>
      ))}

      <div style={{ display: "flex", flexDirection: "row" }}>
        <button
          style={{ backgroundColor: backButtonColor, borderColor: backButtonColor }}
          type="button"
          className="btn btn-primary box-button-left"
          onClick={goPrevious}
        >
          {strings?.find((x) => x.type === TranslationsStringsType.LEFTBUTTON)?.value}
        </button>
        <button
          type="button"
          className="btn btn-primary box-button-right"
          style={{ backgroundColor: buttonColor, borderColor: buttonColor }}
          onClick={goNext}
        >
          {strings?.find((x) => x.type === TranslationsStringsType.MAINBUTTON)?.value}
        </button>
      </div>
    </>
  )
}
